import classNames from 'classnames'
import { motion } from 'framer-motion'
import { ReactNode, useState } from 'react'

interface IProps {
  bgClasses: string
  children: ReactNode
}

export const CardContainerSm: React.FC<IProps> = ({ bgClasses, children }) => {
  const [hovering, setHovering] = useState(false)

  return (
    <motion.div
      animate={{
        scale: hovering ? 1.025 : 1,
        transition: {
          ease: 'easeInOut',
          duration: 0.35
        }
      }}
      className={classNames('rounded-[40px] p-4 hover:cursor-pointer min-w-[180px]', bgClasses)}
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      onClick={() => {}}
    >
      {children}
    </motion.div>
  )
}
